'use client';

import { useEffect, useState } from 'react';
import { useAuthStore } from '@/entities/auth';
import { useCreditInfo } from '@/entities/credit';
import { SOCKET_EVENT, isCreditShortageCode, useSocket } from '@/shared/api';
import type { CreditResultResponse, SocketResponse } from '@/shared/api';
import { useNotEnoughCreditDialog } from './useNotEnoughCreditDialog';
export const useGnbCredit = () => {
  const {
    isAuthenticated
  } = useAuthStore();
  const {
    data
  } = useCreditInfo({
    enabled: isAuthenticated
  });
  const {
    openDialog: openNotEnoughCreditDialog
  } = useNotEnoughCreditDialog();
  const [remainingCredit, setRemainingCredit] = useState(data.balance.remaining_amount);
  useEffect(() => {
    setRemainingCredit(data.balance.remaining_amount);
  }, [data.balance.remaining_amount]);
  const socket = useSocket();
  useEffect(() => {
    if (!isAuthenticated) return;
    const unsubscribe = socket.on<SocketResponse<CreditResultResponse>>(SOCKET_EVENT.NOTIFICATION_CREDIT, response => {
      const {
        data,
        code
      } = response;
      setRemainingCredit(data.remaining_amount);
      if (isCreditShortageCode(code)) {
        openNotEnoughCreditDialog();
      }
    });
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
  return {
    creditInfo: {
      credit: remainingCredit,
      name: 'Credit'
    },
    plan: data.plan,
    discountRate: data.discount_rate
  };
};